import React from 'react';
import RoteirizaAjuda from '../../components/ajuda/roteiriza-ajuda';
import NavBar from '../../components/layout/navbar';

function Ajuda(props) {

    return (
        <>
            <NavBar />
            <RoteirizaAjuda {...props} />
        </>
    )

}

export default Ajuda;